import { SyntacticSugarService } from '../../../../services/sys/syntactic-sugar.service';
import { Directive, OnInit, OnDestroy } from '@angular/core';
import { Subscription ,  Observable } from 'rxjs';
import { CmnUiService } from './../../../../services/ui/cmn-ui.service';
import { ActivatedRoute } from '@angular/router';

declare var jQuery: any;

@Directive({
    selector: 'cmn-focus-on-field',
    standalone: false
})
export class CmnFocusOnFieldDirective implements OnInit, OnDestroy {
	viewLoadedSubscription: Subscription;
	processingModalSubscription: Subscription;
	processingModalStatus = 'closed';

	constructor(
        private route: ActivatedRoute,
        private syntacticSugarService: SyntacticSugarService,
        private cmnUiService: CmnUiService) {
	}

	ngOnInit() {

        
	}

	ngOnDestroy() {
		if(this.viewLoadedSubscription) {
			this.viewLoadedSubscription.unsubscribe();
		}
		if(this.processingModalSubscription) {
			this.processingModalSubscription.unsubscribe();
		}
	}

	viewLoadedHandler(eventData) {
		this.setFocus();
	}

	processingModalToggleHandler(eventData) {
		this.processingModalStatus = eventData;
		if(eventData === 'closed') {
			this.setFocus();
		}
	}

	setFocus() {
		if (this.processingModalStatus === 'closed') {
			setTimeout(() => {
                this.getSpecifiedField().subscribe((field: string) => {
                    if(!this.syntacticSugarService.isStringEmpty(field)) {
                        jQuery("#" + field).focus();
                    } else {
                        jQuery('.pageTransitionWrap').find('a#showOrderButtonsLink0, a#hideOrderButtonsLink0, div#mat-tab-label-0-0, button, .error, .info, .saved, input:enabled, select:enabled, ngb-accordion a, .agreement').first().focus();
                    }
                });
            }, 100);
		}
        this.cmnUiService.scrollAnimate({});
	}
    
    /**
     * If there is a field specified that we should be setting focus to on the route params, return
     * that field name.  This is looking at route.firstChild.firstChild because this component is on 
     * the application.component, and the first child route is the section and the next child route is
     * the view. 
     */
    private getSpecifiedField(): Observable<string> {
        return new Observable(observer => {
            if(!this.syntacticSugarService.isObjectUndefined(this.route.firstChild)) {
                if(!this.syntacticSugarService.isObjectUndefined(this.route.firstChild?.firstChild)) {
                    this.route.firstChild?.firstChild?.params.subscribe(params => {
                        let field = params[ 'fieldOnFocus' ];
                        if(this.syntacticSugarService.isObjectUndefined(field)) {
                            observer.next("");
                            observer.complete();
                        } else {
                            observer.next(field);
                            observer.complete();
                        }
                    });
                } else {
                    observer.next("");
                    observer.complete();
                }
            } else {
                observer.next("");
                observer.complete();
            }
        });
    }
}
